var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.435 12.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.957 4.177H3.73v.353h4.227zM8.752 5.38H3.73v.353h5.022zM6.514 6.582H3.73v.353h2.784z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.074 11.775c0 .198-.069.38-.18.527L8.73 8.898l3.345-2.784zm-10.794.88a.87.87 0 01-.436-.12l3.172-3.411.995.829a1.912 1.912 0 002.45 0l.997-.83 3.171 3.412a.87.87 0 01-.436.12zm-.88-.88v-5.66-.001l3.344 2.784L.58 12.303a.875.875 0 01-.18-.528m.61-7.054l.84-.775V6.86l-1.4-1.165c.084-.37.277-.712.56-.974m9.377-2.487v4.825l-3.15 2.622c-.579.483-1.42.483-1.999 0L2.201 7.154v-4.92zM5.42.644a1.21 1.21 0 011.633 0l1.338 1.237H4.082zm6.044 4.077a1.9 1.9 0 01.561.974l-1.286 1.07V4.052zm-.725-1.15V1.88H8.91L7.293.385a1.564 1.564 0 00-2.113 0L3.563 1.881H1.848v1.584L.77 4.462a2.258 2.258 0 00-.723 1.653v5.66c0 .68.553 1.233 1.233 1.233h9.913c.68 0 1.233-.553 1.233-1.233v-5.66c0-.625-.263-1.228-.722-1.653z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.42646283.svg";
export { ForwardRef as ReactComponent };